<template>
  <div class="flex-grow-1 d-flex flex-column">
    <work-order-process
      v-if="orderInfo"
      style="padding:1rem;margin-bottom:1rem"
      class="selector-container section-container" :class="{'dark':skinType}"
      v-bind:processIndex.sync="stepIndex"
      :processList="orderInfo.ProcessRecords"
    ></work-order-process>
    <el-row class="flex-grow-1 align-items-stretch" type="flex" :gutter="12" v-if="orderInfo">
      <el-col :span="12" class="d-flex flex-column">
        <map-info :warnInfo="briefInfo" class="flex-grow-1"></map-info>
      </el-col>
      <el-col :span="12" class="d-flex flex-column section-container detail-info"
      :class="{'dark':skinType}">
        <section-title title="基本信息">
        </section-title>
        <el-row
          class="brief-info-container d-flex align-items-stretch"
          type="flex"
        >
          <div
            class="brief-info d-flex flex-column flex-grow-1 justify-content-around"
          >
            <el-row
              class="brief-info-row"
              v-for="(briefInfo, index) of briefInfos"
              :key="'brief-info' + index"
              :gutter="20"
            >
              <el-col :span="12" class="d-flex">
                <div
                  class="brief-info-title "
                  :class="{'dark':skinType}"
                  style="text-align: right"
                >
                   {{ briefInfo[0].title }}:
                </div>
                <div
                  class="brief-info-content none-width flex-grow-1"
                  :class="{'dark':skinType}"
                  style="text-align: right"
                >
                  {{ briefInfo[0].content }}
                </div>
              </el-col>
              <el-col :span="12" class="d-flex justify-content-around">
                <div
                  class="brief-info-title " :class="{'dark':skinType}"
                  style="text-align: right"
                >
                <!-- 判断title里面的数据是否为空，为空则不加:，不为空就加: -->
                 {{briefInfo[1].title? briefInfo[1].title+':': ''}}
                </div>
                <div
                  class="brief-info-content none-width flex-grow-1"
                  :class="{'dark':skinType}"
                  style="text-align: right"
                >
                  {{ briefInfo[1].content }}
                </div>
              </el-col>
            </el-row>
          </div>
        </el-row>
        <div class="none-height flex-grow-1 d-flex flex-column work-steps align-items-stretch">
          <div class="d-flex align-items-center justify-content-between">
            <section-title title="工单详情"></section-title>
          </div>
          <work-step :stepInfo="stepInfo"
           class="none-height flex-grow-1"
           style=""></work-step>
        </div>
      </el-col>
    </el-row>
  </div>
</template>
<script>
import WorkStep from '@/components/equipment-operational/components/work-detail/work-step.vue';
import MapInfo from '@/components/utils/map-info.vue';
import SectionTitle from '@/components/utils/section-title.vue';
import WorkOrderProcess from '@/components/equipment-operational/components/work-detail/work-order-process.vue';
import { GetProcessDetailsNew } from '@/api/workorder-management/workorder-management';

export default {
  name: 'work-detail',
  components: {
    MapInfo,
    WorkStep,
    SectionTitle,
    WorkOrderProcess,
  },
  data() {
    return {
      processId: '804db68d-9e1b-5402-6b24-85a106caf9af',
      warnId: '611682',
      briefInfo: {},
      keyNameMap: new Map([
        ['F_ProcessName', '工单名称'],
        ['F_CreateDate', '创建时间'],
        ['WarnGrade', '告警级别'],
        ['WarningReason', '告警类型'],
        ['WarningValue', '告警值'],
        ['WarningRange', '告警范围'],
        ['F_NodeName', '当前步骤'],
      ]),
      // 当前工单步骤
      stepInfo: {
      },
      // 工单信息
      orderInfo: null,
      // 步骤顺序
      stepIndex: 0,
      lastActiveStepIndex: 0,
    };
  },
  created() {
    this.getIds();
    this.requestWorkDetail();
  },
  watch: {
    stepIndex(newVal) {
      this.stepInfo = this.orderInfo.ProcessRecords[newVal];
    },
  },
  computed: {
    briefInfos() {
      const keys = [...this.keyNameMap.keys()];
      const arrs = [];
      for (let i = 0; i < keys.length; i += 2) {
        const key0 = keys[i];
        const key1 = keys[i + 1];
        arrs.push([
          { title: this.keyNameMap.get(key0), content: this.briefInfo[key0] },
          { title: this.keyNameMap.get(key1), content: this.briefInfo[key1] },
        ]);
      }
      return arrs;
    },
    skinType() {
      return this.$store.getters.skinType;
    },
  },
  methods: {
    getIds() {
      this.warnId = this.$route.params.wId;
      this.processId = this.$route.params.id;
    },
    manageProcess() {

    },
    requestWorkDetail() {
      GetProcessDetailsNew({
        ProcessId: this.processId,
        WRID: this.warnId,
      }).then((res) => {
        [this.orderInfo] = res;
        const { stepIndex } = this.getInitialStepInfo(res[0]);
        [this.briefInfo] = this.orderInfo.WarnRecords;
        this.lastActiveStepIndex = stepIndex;
        if (this.stepIndex === stepIndex) {
          this.stepInfo = this.orderInfo.ProcessRecords[this.stepIndex];
        } else {
          this.stepIndex = stepIndex;
        }
      });
    },
    // 获取初始步骤信息
    getInitialStepInfo(orderInfo) {
      const stepIndex = orderInfo.ProcessRecords.findIndex(
        (process, index, list) => process.F_CreateDate && (!list[index] || !list[index + 1]),
      );
      const stepInfo = orderInfo.ProcessRecords[stepIndex];
      return {
        stepIndex,
        stepInfo,
      };
    },
  },
};
</script>
<style scoped>
.selector-container{
  padding: 1rem;
  margin-bottom: 1rem;
}
.brief-info-container {
  padding: 1rem;
  font-size:1.2rem
}
.brief-info-row+.brief-info-row{
  margin-top: 0.5rem;
  /* background-color: red; */
  /* color: blue; */
}
.brief-info{
  padding:0rem 1.0rem 0.6rem;
}
.brief-info-title {
  color: #999999;
}
.brief-info-title.dark {
    color:white;
    font-size: 16px;
    font-weight: bold;
    line-height: 40px;
  /* color: red; */
  /* color: #999999; */
}

.brief-info-content {
  color: #111111;
}
.brief-info-content.dark{
  font-size: 15px;
  text-align: center;
  margin: auto;
  color: #EEEEEE;
}
.detail-info{
  padding: 1rem;
}
</style>
